import type { PolymorphicComponent } from '@hh.ru/magritte-types';
import type { BreadcrumbsItemProps } from '@hh.ru/magritte-ui-breadcrumbs/types';
import { Link } from '@hh.ru/magritte-ui-link';
import { Text } from '@hh.ru/magritte-ui-typography';

import styles from './breadcrumbs.less';

export const BreadcrumbsItem: PolymorphicComponent<BreadcrumbsItemProps, 'a'> = ({
    Element = 'a',
    children,
    ...rest
}) => {
    return (
        <Link Element={Element} {...rest} typography="label-3-regular" inline>
            <div className={styles.interactiveText}>
                <Text Element="span" typography="label-3-regular">
                    {children}
                </Text>
            </div>
        </Link>
    );
};
